import { SessionStorageProvider} from "@state";
import { DefaultPath } from "./defaultRoutePathsEnum";
import { getCurrentCulture } from "@utils";

export function redirectToHomePage() {
	window.location.href = `/${getCurrentCulture()}/${DefaultPath.HOME}`;
}

export async function resetSession() {
	if (App.state.rootStore.userAuthStore.isLoggedIn) {
		await App.state.rootStore.userAuthStore.logoutUser();
	} else {
		App.state.rootStore.userAuthStore.removeUserFromLocalStorage();
	}

	SessionStorageProvider.remove("slip");
	SessionStorageProvider.remove("clicked-tips");
	SessionStorageProvider.remove("bb-clicked-tips");
	SessionStorageProvider.remove("system");

	redirectToHomePage();
}
